export default __webpack_public_path__ + "UI/assets/media/secondaryStar-33f36797.svg";